import React from 'react';
import style from './KimGroup.module.scss';
import KimCustomersDynamicsInfo from '../../blocks/PageInfo/KimGroupIngo/KimCustomersDynamicsInfo';

const KimCustomersDynamics: React.FC = () => (
  <>
    <div className={style.container}>
      <KimCustomersDynamicsInfo />
    </div>
    <div className={style.frame}>
      <iframe
        width="100%"
        height="100%"
        src="https://pix.tektorg.ru/shared/view/c7e477de-04a8-4fbf-9ddb-53bc0dda7201"
        title="kim-customers-dynamics"
      />
    </div>
  </>
);

export default KimCustomersDynamics;
